import types from 'dashboard/store/mutation-types';
import ConversationApi from 'dashboard/api/inbox/conversation';

/**
 * Loads the conversation a route points at when it is not in the store yet.
 *
 * Since 4.13 the `getConversation` action no longer works for this on the mentions and
 * participating views: it commits UPDATE_CONVERSATION, which skips a conversation missing
 * from those lists so realtime events do not leak unrelated chats into them (#11714). A link
 * straight to such a conversation then rendered a blank pane. ADD_CONVERSATION only guards
 * against duplicates, so the route's own conversation always lands in the store.
 *
 * @param {import('vuex').Store} store
 * @param {number|string} conversationId
 */
export async function fetchRouteConversation(store, conversationId) {
  try {
    const { data } = await ConversationApi.show(conversationId);
    store.commit(types.ADD_CONVERSATION, data);
    store.commit(`contacts/${types.SET_CONTACT_ITEM}`, data.meta.sender);
  } catch (error) {
    // Like getConversation: an unknown or forbidden conversation leaves the pane empty.
  }
}
